module.exports = __webpack_public_path__ + "static/img/formula.b553c4ca.png";